import { ballArr, count, singleDouble, smallBig, dragonTiger } from '../resPatterns.js';

function setBallMap(start, len) {
  let res = {};
  for (let i = start; i <= len; i++) {
    res[i] = {
      arrs: [],
      key: i,
      last: ''
    };
  }
  return res;
}

const getBallRoads = (ballsMap, data) => {
  if (data.length == 0) {
    return [];
  }

  let handleData = data.reduce((a, b) => {
    let arr = ballArr(b.resultStr);
    console.log('arr', arr)
    Object.keys(a).map(x => {
      if (~arr.indexOf(Number(x))) {
        if (a[x].last === 1) {
          a[x].arrs[a[x].arrs.length - 1].push(1);
        } else {
          a[x].last = 1;
          a[x].arrs.push([1]);
        }
      } else {
        if (a[x].last === 0) {
          a[x].arrs[a[x].arrs.length - 1].push(0);
        } else {
          a[x].last = 0;
          a[x].arrs.push([0]);
        }
      }
    });

    return a;
  }, ballsMap);
  return Object.entries(handleData)
    .sort((a, b) => a[0] - b[1])
    .map(x => {
      return {
        name: `号码${x[0]}`,
        data: x[1]
      };
    });
};

export default (type, data) => {
  if (type == 'ssc') {
    return getBallRoads(setBallMap(0, 9), data);
  }
  if (type == 'ks') {
    return getBallRoads(setBallMap(0, 6), data);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/statistic/getBallRoads.js